import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "../../../styles/orders.css";
import VerifiedNavigation from "../../navigation/components/VerifiedNavigation";
import { OrderServices } from "../services/OrderServices";
import { AuthServices } from "../../auth/services/AuthServices";
import { trackPageView } from "../../../utils/analytics";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const location = useLocation();

  const fetchOrders = async () => {
    const response = await OrderServices.fetchOrders();
    if (response.status !== 200) {
      console.log("There was an error fetching your orders", response);
    }
    setOrders(response.data);
  };

  const handleSelect = async () => {
    await OrderServices.updateOpenStatus();
    setIsOpen((prev) => !prev);
  };

  const handleViewReadyOrder = () => {};

  const fetchProfile = async () => {
    const response = await AuthServices.fetchProfile();
    setIsOpen(response.data?.user?.open);
  };

  // useEffect(() => {
  //   socketRef.current?.on("order-update", async (newOrder) => {
  //     setOrders((prevOrders) => [...prevOrders, newOrder.orderDetails]);
  //   });
  // }, []);

  useEffect(() => {
    fetchProfile();
  }, [isOpen]);

  useEffect(() => {
    fetchOrders();
    const interval = setInterval(() => {
      fetchOrders();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="orders">
      <VerifiedNavigation setOrders={setOrders} />
      <div className="orders-container">
        <div className="orders-header">
          <h2>Orders</h2>
          <div className="order-search-container">
            {/* <div className="order-searchbar-container">
              <BiSearch />
              <input
                placeholder="Search"
                type="text"
                name=""
                id="order-search"
              />
            </div> */}
            <select
              onChange={handleSelect}
              value={isOpen ? "open" : "closed"}
              name="select"
              id="order-select"
            >
              <option value="open">Open</option>
              <option value="closed">Closed</option>
            </select>
          </div>
        </div>
        {orders && orders.length > 0 ? (
          <div className="order-status-container">
            <div className="orders-column">
              <h2>Preparing</h2>
              {orders
                .filter(
                  (order) =>
                    order.orderStatus === "pending" ||
                    order.orderStatus === "confirmed"
                )
                .map((order, index) => (
                  <div
                    key={index}
                    className={`order-row ${
                      order.orderStatus !== "pending"
                        ? "order-acknowledged"
                        : ""
                    }`}
                  >
                    <div className="order-row-left">
                      <p>{order.customer.name}</p>
                      <p>{order.orderNumber}</p>
                    </div>
                    <div className="order-row-right">
                      <p>New</p>
                      <p>{order.orderAtFormatted}</p>
                      <Link to={`/manager/orders/${order.orderNumber}`}>
                        <button>
                          {order.orderStatus === "pending" ? "Accept" : "Ready"}
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
            </div>

            <div className="orders-column">
              <h2>Ready</h2>
              {orders
                .filter((order) => order.orderStatus !== "pending" && order.orderStatus !== "confirmed")
                .map((order, index) => (
                  <div
                    key={index}
                    className={`order-row ${
                      order.orderStatus !== "pending"
                        ? "order-acknowledged"
                        : ""
                    }`}
                  >
                    <div className="order-row-left">
                      <p>{order.customer.name}</p>
                      <p>{order.orderNumber}</p>
                    </div>
                    <div className="order-row-right">
                      <p></p>
                      {/* <p>Arriving now</p> */}
                      <Link to={`/manager/orders/${order.orderNumber}`}>
                        <button>View</button>
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ) : (
          <p className="no-orders">
            Orders will show up here when you receive them
          </p>
        )}
      </div>
    </div>
  );
};

export default Orders;
